import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class CustomerAPI {

  static ModelNo = 1;

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    
    fetch(Config.app.link + 'api/customer/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const body = { filter: filter, page: page, perPage: perPage };
    
    fetch(Config.app.link + 'api/customer/list/count', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/customer/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (customer, success, failure) => {
    fetch(Config.app.link + 'api/customer/add-edit', new Header('POST', customer))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/customer/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default CustomerAPI;